import { Typography } from 'antd'
import { InspectionStatus } from 'features/inbox/types/types'
import styled from 'styled-components'
import CantileverTheme from 'styles/cantileverTheme'

export const StatusBadge = styled.div<{ $status: InspectionStatus }>`
  background: ${(props) => {
    switch (props.$status) {
      case 'scheduled':
        return CantileverTheme.colors.grayscale['500']
      case 'in_progress':
        return CantileverTheme.colors.blue['500_base']
      case 'completed':
        return CantileverTheme.colors.success['500']
      case 'data_validation':
        return CantileverTheme.colors.blue['500_base']
      case 'preliminary_results_available':
        return CantileverTheme.colors.success['500']
      default:
        return CantileverTheme.colors.grayscale['500']
    }
  }};

  color: ${CantileverTheme.colors.grayscale['100']};
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const InspectionTypeBadge = styled.div`
  background: ${CantileverTheme.colors.grayscale['600']};
  color: ${CantileverTheme.colors.grayscale['200']};
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const CardTitle = styled(Typography.Title)`
  &.ant-typography {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: ${CantileverTheme.colors.grayscale['200']};
    line-height: 1.3;
    flex: 1;
  }
`

export const CardSubtitle = styled(Typography.Text)`
  &.ant-typography {
    color: ${CantileverTheme.colors.grayscale['400']};
    font-size: 0.875rem;
    font-weight: normal;
    margin: 0.25rem 0 0 0;
    display: block;
  }
`

export const MetricLabel = styled(Typography.Text)`
  &.ant-typography {
    color: ${CantileverTheme.colors.grayscale['400']};
    font-size: 0.75rem;
    margin: 0;
  }
`

export const MetricValue = styled(Typography.Text)`
  &.ant-typography {
    color: ${CantileverTheme.colors.grayscale['200']};
    font-size: 0.875rem;
    font-weight: 600;
    margin: 0;
  }
`

export const DateBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0 0.4375rem;
  height: 1.375rem;
  line-height: 1.25rem;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-sizing: border-box;

  .anticon {
    font-size: 0.75rem;
    opacity: 0.7;
  }
`

export const StatusBadgesContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`

export const MetricsContainer = styled.div<{ $withMargin?: boolean }>`
  display: flex;
  gap: 2rem;
  ${(props) => props.$withMargin && 'margin: 0.5rem 0;'}
`

export const OverviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
`
